<template>
  <v-container>
    <v-card outlined class="mx-auto" width="750px" style="border-color:transparent;">
      <v-layout wrap>
          <v-autocomplete dense outlined  rounded class="ma-1" style="height: 40px; width: 220px;" 
            id="farm" 
            ref="farm" 
            label="농장/사업장✽" 
            v-model="farm"
            :items="farmItems"
            :menu-props="{ top: false, offsetY: true }"
            no-data-text="자료(권한)이 없습니다."
            item-text="name"
            return-object
            @change="changeFarm()"
            @focus="comboFarms()"
            clearable
          />
          <v-autocomplete dense outlined rounded class="ma-1" style="height: 45px; width: 220px;"
              id="building" 
              ref="building" 
              label="축사/건물/구역✽" 
              v-model="building"
              :items="buildingItems"
              :menu-props="{ top: false, offsetY: true }"
              no-data-text="자료(권한)이 없습니다."
              item-text="name"
              return-object
              @change="changeBuilding()"
              @focus="comboBuildings()"
              clearable
            />
          <v-btn class="elevation-5 ma-1 rounded-pill normal-btn" style="height: 40px; width: 100px"
            id="refreshList" 
            :loading="loading" 
            ref="refreshList" 
            @click="refreshList()">
            <img src="@/assets/icon_refresh.svg" alt="새로고침" />
            새로고침
          </v-btn>
        </v-layout>
      </v-card>
    <v-card outlined style="display:grid; place-content: center; border-color:transparent;">
      <WeatherInfo
            :wheather_info="wheather_info"
            @gowatt="gowatt()"
          />
    </v-card>
    <div id="cardRoomInfo" class="mx-auto" >
      <div id="roomBox" class="mb-2" v-for="room in items" :key="room.room_cd" @click="clickRoom(room)">
          <div class="info_room" :class="{gray: room.checkTime ==='-'}">
            <span>{{ room.room_name }}</span>
          </div>

            <div id="textArea">
              <div class="info_sensor">
                <div class="text_name">온도</div>
                <div class="text_number"> {{ room.temp }}
                  <span class="text_number_unit"> ℃ </span>
                </div>
              </div>

              <div class="info_sensor">
                <div class="text_name">습도</div>
                <div class="text_number"> {{ room.hum }}
                  <span class="text_number_unit"> % </span>
                </div>
              </div>

              <div class="info_sensor" v-if="room.co2!=='-'">
                <div class="text_name">이산화탄소</div>
                <div class="text_number"> {{ room.co2 }}
                  <span class="text_number_unit"> ppm </span>
                </div>
              </div>

              <div class="info_sensor" v-if="room.nh3!=='-'">
                <div class="text_name">암모니아</div>
                <div class="text_number"> {{ room.nh3 }}
                  <span class="text_number_unit"> ppm </span>
                </div>
              </div>


              <div class="info_sensor" v-if="room.h2s!=='-'">
                <div class="text_name">황화수소</div>
                <div class="text_number"> {{ room.h2s }}
                  <span class="text_number_unit"> ppm </span>
                </div>
              </div>
            </div>
          </div>
        </div>

      
        <v-row justify="center" width="750px">
          <v-col cols="auto">
          <v-autocomplete dense  class="interval" 
              id="setInterval" 
              ref="setInterval"
              label="" 
              :items="setIntervalItems"
              item-text="descripton"
              return-object
              v-model="setInterval"
              @change="refreshList()"
            />  
          </v-col>
          <v-col cols="auto">
            <span>마다 새로고침</span>
          </v-col>
        </v-row>


    <!-- <v-hover v-slot="{hover}">
      <v-btn fab outlined class="mobile_btn" alt="방별 모니터링 현황판" @click="roomMonitoring(building)">
        <v-icon color=white large>
          mdi-view-dashboard
        </v-icon>
      
        <v-expand-transition>
          <div v-if="hover" class="hover" transition="scale-transition">
            <div style="padding:10px; text-align:right;">방별<br/>현황판</div>
          </div>
        </v-expand-transition>
      </v-btn>
    </v-hover> -->
  </v-container>
</template>

<script>
import Apis from '@/api/apis'
import VueCookies from "vue-cookies";
import dateUtil from "@/utils/custom/dateProperty.js";
import WeatherInfo from "./child/WeatherInfo.vue";
var setTime = 0;

export default{
  name: "CardRoomTablet",
  components: {
    WeatherInfo,
  },

  async created() {
    Apis.pageCount({ //페이지뷰 카운터
      page_name: this.$route.name,
      url: this.$route.path,
      division: "pigro",
    },() => {  // 정상처리
      // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });

    this.isreload = true;
    await this.comboFarms();
    await this.comboBuildings();

    let cookie_interval = VueCookies.get("tablet_interval");
      if (cookie_interval !== "undefined" && cookie_interval) {
        // console.log("쿠 키interval",cookie_interval);
        this.setInterval = cookie_interval;
    } 

    let cookie_info = VueCookies.get("cardroomtablet_info");

    if (cookie_info) {
      // console.log("쿠키",cookie_info);
      this.farm = cookie_info.farm || {};
      this.building = cookie_info.building || {};
    } else {
      this.farm = this.farmItems[0];
    }
    this.refreshList();
    },


  data() {
    return {
      isreload: false,
      items: [],

      farm : {},
      farmItems : [],
      building : {},
      buildingItems : [],

      loading: false,
      wheather_info: {},

      setInterval: {min: 30, descripton: "30 분"},
      setIntervalItems: [
        { min: 10, descripton: "10 분"},
        { min: 20, descripton: "20 분"},
        { min: 30, descripton: "30 분"},
        { min: 60, descripton: "1 시간"},
      ],

    };
  },
  destroyed() {
    clearTimeout(setTime);
    // console.log("clearTimeout",setTime);
  },


  methods: {
    refresh() {
      clearTimeout(setTime);
      this.refreshList();
    },

    refreshList() {
      this.$store.commit("resMessage","");
      if (!this.farm || !this.farm.code ) {
        alert("축사/건물/구역 또는 농장/사업장를 선택하세요");
        this.$refs.building.focus();
        return;
      }
      this.loading = true;

      this.refreshWeatherInfo();

      let preItems = JSON.parse(sessionStorage.getItem("summaryData"));
      if (preItems) {
        this.items = preItems;
        sessionStorage.removeItem("summaryData");
        this.loading = false;
      } else {
        // console.log("리스트");
        Apis.monitoringSummary({
          farm_cd: this.farm && this.farm.code || "",
          building_cd: this.building && this.building.code || "",
          stand_dt: dateUtil.format(new Date(), "yyyy-MM-dd HH:mm:ss"), 
        } ,(res) => {  // 정상처리
          this.items = res.data;
          // console.log(res.data);
          if (this.msgFlag) this.$store.commit("resMessage",res.message);
          this.msgFlag = true;
          this.loading = false;

          let cookie_info = { farm: this.farm, building: this.building };
          let cookie_interval = this.setInterval;
          VueCookies.set("cardroomtablet_info" ,cookie_info,"30d");
          VueCookies.set("tablet_interval" ,cookie_interval,"30d");

          this.$route.path == "/monitoring/cardroomtablet" ? setTime = setTimeout( () =>  this.refreshList(), this.setInterval.min * 60 * 1000) : "" ;

          // console.log("path",this.$route.path);
        }).catch( (err) => {  // 개별 API 오류 처리 예제
          console.log("monitoringSummary 호출 오류",err);
          // alert("monitoringSummary 호출 오류" + err);
          this.$router.push("/");
          this.loading = false;
        })
      } 
    },
    gowatt(){
      sessionStorage.setItem("summaryData",JSON.stringify(this.items));
      this.$router.push({
        name: "WattageDetail",
        params: { company: this.company, 
          farm: this.farm }
      });
    },

    clickRoom(room) {
      // console.log("click",room);
      this.$router.push({
        name: "RoomMonitor",
        params: { 
          company: {code: room.company_cd, name: room.company_name},
          farm: {code: room.farm_cd, name: room.farm_name},
          building: {code: room.building_cd, name: room.building_name},
          room: {code: room.room_cd, name: room.room_name },
          }
      });
    },
    
    refreshWeatherInfo() {
      Apis.monitoringWeather({
        farm_cd: this.farm.code,
      } ,(res) => {
        // NOTE: 해당 농장/사업장정보에 등록된 위치정보 기반 날씨 정보
        // console.log("weather=",res.data)
        this.wheather_info = res.data;
      });
    },

    async comboFarms() {
      await Apis.comboFarms({
        company_cd: "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.farmItems = [];
            for (let i in res.data) {
            this.farmItems.push({
              company_cd: res.data[i].company_cd, 
              company_name: res.data[i].company_name, 
              code: res.data[i].farm_cd,
              name: res.data[i].farm_name,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboFarms API 호출 오류",err)
            // alert(err);
        }
      ) 
    },
    async changeFarm() {      // 하위콤보 선택시 상위 콤보 동시 세팅, 하위콤보 지우기
      this.building = {};
      this.buildingItems = [];

      if(this.farm && this.farm.code){
        await this.comboBuildings();
        if(this.farm) this.building = this.buildingItems[0];
      }
    },
    async comboBuildings() {
      await Apis.comboBuildings({
        company_cd:this.company &&  this.company.code || "",
        farm_cd: this.farm && this.farm.code || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.buildingItems = [];
            for (let i in res.data) {
            this.buildingItems.push({
              company_cd: res.data[i].company_cd, 
              company_name: res.data[i].company_name, 
              farm_cd: res.data[i].farm_cd, 
              farm_name: res.data[i].farm_name, 
              code: res.data[i].building_cd,
              name: res.data[i].building_name,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboBuildings API 호출 오류",err)
        }
      ) 
    },
    changeBuilding() {      // 하위콤보 선택시 상위 콤보 동시 세팅, 하위콤보 지우기
      if (this.building && this.building.farm_cd) {
        this.farm = {code: this.building.farm_cd, name: this.building.farm_name};
      }
    },
  },
};

</script>

<style lang="scss" scoped>
#cardRoomInfo {
  position: relative;
  width: calc(100% - 10px);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

#roomBox{
  width: 230px;
  height: 260px;
  margin: 2px 10px 10px 0;
  border: solid 1px #3a4f3f !important;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
}
#textArea {
  margin: 0px 12px 0px 12px;
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.info_room {
  font-size: 23px !important;
  font-weight: bold !important;
  letter-spacing: -0.6px;
  height:50px;
  background-color: #6B7B6E;
  line-height: 50px;
  border-radius: 10px 10px 0 0;
  color: white;
}
.info_sensor{
  display: flex;
  justify-content: space-between;
  align-content: center;
  color:#3a4f3f;
  height:40px;
  line-height: 40px;
}
.text_name{
  font-size:20px;
  letter-spacing:-0.78px;
}
.text_number {
  font-size: 25px;
  font-weight:bold;
  letter-spacing: -1px;
}

.text_number_unit {
  height: 35px;
  font-size: 15px;
  margin-left: 5px;
  line-height: 42px;
}

.normal-btn{
  align-content: center !important;
  color:white !important;
  font-weight: bold !important;
  background-color: #3a4f3f !important;
}

.gray{
  background-color: #868686
}

.mobile_btn{
  position:fixed;
  right:20px;
  bottom: 35px;
  height:50px !important;
  width:50px !important;
  line-height:50px !important;
  color:white !important;
  background-color: #3a4f3f !important;
}

.hover{
  position:fixed;
  right:20px;
  bottom:90px;
  background-color: #658774;
  color:white;
  border-radius: 10px;
}


</style>
